import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ArquivoExtensaoPipeModule } from '../../../extensoes/pipes';

import { ArquivoTableComponent } from './arquivo-table.component';

@NgModule({
    imports: [
        SharedModule,
        ArquivoExtensaoPipeModule
    ],
    declarations: [
        ArquivoTableComponent
    ],
    exports: [
        ArquivoTableComponent
    ]
})
export class ArquivoTableModule { }
